import { submissionMillis } from "../hooks/ContactSubmissionsHook";

// CSV columns (order + header labels). Excludes ipHash / userAgent by design.
const COLUMNS = [
  ["firstName", "First Name"],
  ["lastName", "Last Name"],
  ["email", "Email"],
  ["phone", "Phone"],
  ["organization", "Organization"],
  ["message", "Message"],
  ["formName", "Form"],
  ["pagePath", "Page"],
  ["status", "Status"],
  ["createdAt", "Created At"],
];

const toIso = (ts) => {
  const ms = submissionMillis(ts);
  return ms ? new Date(ms).toISOString() : "";
};

// Escape a single CSV field (wrap in quotes, double internal quotes).
const escapeField = (value) => {
  const str = value === undefined || value === null ? "" : String(value);
  return `"${str.replace(/"/g, '""')}"`;
};

// Build a CSV string from an array of submission rows.
export const buildSubmissionsCsv = (rows) => {
  const header = COLUMNS.map(([, label]) => escapeField(label)).join(",");
  const lines = rows.map((row) =>
    COLUMNS.map(([key]) =>
      escapeField(key === "createdAt" ? toIso(row[key]) : row[key])
    ).join(",")
  );
  return [header, ...lines].join("\r\n");
};

// Trigger a client-side download of the CSV.
export const downloadSubmissionsCsv = (rows) => {
  const csv = buildSubmissionsCsv(rows);
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  link.href = url;
  link.download = `contact-submissions-${stamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
